// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wCp5d","importantInfo":"styles_importantInfo__1Oojl"};